import React from "react";
import PropTypes from 'prop-types';
import * as Sentry from "@sentry/react";

export class ErrorBoundary extends React.Component {
  componentDidCatch(error, {componentStack}) {
    Sentry.captureException(error, {contexts: {react: {componentStack}}});
  }

  render() {
    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.element.isRequired,
};
